import { render } from "./preview-modal.vue?vue&type=template&id=16bfbce4&scoped=true"
import script from "./preview-modal.vue?vue&type=script&lang=js"
export * from "./preview-modal.vue?vue&type=script&lang=js"

import "./preview-modal.vue?vue&type=style&index=0&id=16bfbce4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16bfbce4"]])

export default __exports__